const BankAddressHeader = () => {
  return (
    <div className="mx-5">
      <img
        src={"https://cdn.firouzeh.com/public/bank-address-icon.svg"}
        alt="address"
        className="mx-auto my-6"
      />
      <p className=" text-gray-4 body-14px-regular">
        برای ارسال فیروزه کارت آدرس خود را وارد کنید. کارت به ادرس انتخابی شما
        ارسال خواهد شد.
      </p>
    </div>
  );
};
export default BankAddressHeader;
